import { Observable, of } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { AppRoutes, Log } from '@core';
import { Router } from '@angular/router';

export class AppUrlOpenStep extends StartupStep {
  private readonly router: Router = inject(Router);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'AppUrlOpenStep START' });

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.logger.log(Log.Startup, { message: '[AppUrlOpen] Received URL', data: { url: event.url } });

      try {
        const url: URL = new URL(event.url);
        const path: string = url.pathname;

        if (path && path !== '/') {
          this.logger.log(Log.Startup, { message: '[AppUrlOpen] Navigating to', data: { path } });
          this.router.navigateByUrl(path);
        } else {
          this.logger.log(Log.Startup, { message: '[AppUrlOpen] Navigating to root' });
          this.router.navigate([AppRoutes.ROOT]);
        }
      } catch (error) {
        this.logger.log(Log.Startup, { message: '[AppUrlOpen] Error parsing URL', data: { error } });
      }
    });

    this.logger.log(Log.Startup, { message: 'AppUrlOpenStep COMPLETED' });
    return of(state);
  }
}
